import React, { useState } from 'react';
import { Users, Clock } from 'lucide-react';
import StaffManagement from '../components/StaffManagement';
import StaffOrderHistory from '../components/StaffOrderHistory';

const StaffManagementView = ({ currentUser }) => {
  const [activeTab, setActiveTab] = useState('management');

  const tabs = [
    { id: 'management', label: 'Staff Management', icon: <Users className="w-4 h-4" /> },
    { id: 'history', label: 'Order History', icon: <Clock className="w-4 h-4" /> }
  ];

  return (
    <div className="p-6">
      {/* Tab Navigation */}
      <div className="border-b border-gray-200 mb-6">
        <nav className="flex space-x-8">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center space-x-2 py-2 px-1 border-b-2 font-medium text-sm ${
                activeTab === tab.id
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              {tab.icon}
              <span>{tab.label}</span>
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      {activeTab === 'management' && <StaffManagement currentUser={currentUser} />}
      {activeTab === 'history' && <StaffOrderHistory currentUser={currentUser} />}
    </div>
  );
};

export default StaffManagementView;